export default "__VITE_ASSET__7a34847c__"